export default {
    bloglist: {
        all: [
            {
                title: 'GB WhatsApp Update Latest version v18.50',
                poster: require('@/assets/Update-V1840.webp'),
                desc: "Discover the latest features in GB WhatsApp v18.50,including whether it is necessary to update GBWhatsApp, the latest version features, how to update to the latest version, etc.",
                name: 'blog1',
                url: 'https://gbmodshub.com/news/gb-whatsapp-update-v1840/',
                date:"21/05/2025",
                column: 'GBWhatsApp Update',//栏目
                link:'https://gbmodshub.com/news/gbwhatsapp-update/',
            },
            {
                title: 'What is GB WhatsApp? Learn How to Use It Safely in 2025',
                poster: require('@/assets/what-is-GB-WhatsApp.webp'),
                desc: "Discover what GB WhatsApp is, how it works, and how to use it securely in 2025. Get insights into features, privacy settings, and safe installation tips to avoid bans or fake APKs.",
                name: 'blog2',
                url: 'https://gbmodshub.com/news/what-is-gbwhatsapp/',
                date:"21/05/2025",
                column: 'GB WhatsApp Tricks',//栏目
                link:'https://gbmodshub.com/news/tricks/',
            },
            {
                title: 'How to Install GB WhatsApp Safely',
                poster: require('@/assets/blog-3.webp'),
                desc: "Discover how to install GB WhatsApp safely and quickly on your Android device with this step-by-step guide, including FAQs and expert tips.",
                name: 'blog3',
                url: 'https://gbmodshub.com/how-to-install-gb-whatsapp/',
                date:"23/05/2025",
                column: 'GB WhatsApp Tricks',//栏目
                link:'https://gbmodshub.com/news/tricks/',
            },
            {
                title: 'How to Update GB WhatsApp: A Complete Guide for 2025',
                poster: require('@/assets/blog-4.webp'),
                desc: "Learn how to safely update GB WhatsApp TDK to the latest version. Follow our step-by-step guide to back up your chats, install the new APK.",
                name: 'blog4',
                url: 'https://gbmodshub.com/how-to-update-gb-whatsapp/',
                date:"26/05/2025",
                column: 'GBWhatsApp Update',//栏目
                link:'https://gbmodshub.com/news/gbwhatsapp-update/',
            },
            {
                title: 'Advanced Customization Options in GB WhatsApp',
                poster: require('@/assets/blog-5.webp'),
                desc: "Discover the advanced customization options in GB WhatsApp that let you personalize chats, privacy settings, themes, and more like never before.",
                name: 'blog5',
                url: 'https://gbmodshub.com/advanced-customization-options-in-gb-whatsapp/',
                date:"28/05/2025",
                column: 'GB WhatsApp Tricks',//栏目
                link:'https://gbmodshub.com/news/tricks/',
            },
            {
                title: 'Take Control: Unlocking Enhanced Privacy Settings in GB WhatsApp',
                poster: require('@/assets/blog-6.webp'),
                desc: "Step beyond basic privacy! Discover how Enhanced Privacy Settings in GB WhatsApp give you full control over your digital footprint and secure messaging.",
                name: 'blog6',
                url: 'https://gbmodshub.com/enhanced-privacy-settings-in-gb-whatsapp/',
                date:"04/06/2025",
                column: 'GB WhatsApp Tricks',//栏目
            },
            {
                title: 'Why Is My Phone Not Downloading or Installing GB WhatsApp?',
                poster: require('@/assets/blog-7.webp'),
                desc: "Trouble installing GB WhatsApp on Android? Learn why your phone won't download or install the APK and how to fix issues like unknown sources, Play Protect, storage, and version compatibility.",
                name: 'blog7',
                url: 'https://gbmodshub.com/gb-whatsapp-not-install-or-download-fix/',
                date:"13/06/2025",
                column: 'Download Tips',//栏目
            },
            {
                title: 'Why GB WhatsApp Risks Don\'t Stop Its Users',
                poster: require('@/assets/gb-whatsapp-risks.webp'),
                desc: "GB WhatsApp risks haven't stopped users from downloading it. Discover why it remains popular in 2025 and how to stay safe with the latest version.",
                name: 'gb-whatsapp-risks-blog',
                url: 'https://gbmodshub.com/why-gb-whatsapp-risks-don\'t-stop-its-users/',
                date:"01/07/2025",
                column: 'GB WhatsApp News',//栏目
            },
            {
                title: 'How to Save WhatsApp Status: The Easy Way with GBWhatsApp',
                poster: require('@/assets/saveWhatsAppStatus.webp'),
                desc: "Looking to save WhatsApp Status updates? GBWhatsApp simplifies the process with an integrated download button. One tap is all it takes to keep what matters.",
                name: 'blog9',
                url: 'https://gbmodshub.com/how-to-save-whatsapp-status/',
                date:"16/07/2025",
                column: 'GB WhatsApp Tricks',//栏目
                link:'https://gbmodshub.com/news/tricks/',
            },
            {
                title: 'GB WhatsApp v18.60 Released – Fixed Banned Numbers & More!',
                poster: require('@/assets/blog-10.webp'),
                desc: 'GB WhatsApp v18.60 fixes banned number issues, adds new privacy tools, performance upgrades, and fresh themes—download the July 2025 update now!',
                name: 'blogs-10',
                url: 'https://gbmodshub.com/gb-whatsapp-v18.60-released-fixed-banned-numbers/',
                date: '22/07/2025',
                column: 'GBWhatsApp Update',
                link: 'https://gbmodshub.com/news/gbwhatsapp-update/'
            },
            {
                title: 'How GB WhatsApp Ensures Strong Data Protection for Users',
                poster: require('@/assets/blog-11.webp'),
                desc: 'Data protection is key with GB WhatsApp. Discover how its unique privacy tools keep your messages, personal info, and conversations secure and private.',
                name: 'blog-11',
                url: 'https://gbmodshub.com/how-gb-whatsapp-protects-your-data/',
                date: '30/07/2025',
                column: 'GB WhatsApp Tricks',
                link: 'https://gbmodshub.com/news/tricks/'
            },
            {
                title: 'FM WhatsApp vs GB WhatsApp Features: What Makes FM Stand Out',
                poster: require('@/assets/fm-whatsapp-vs-gb-whatsapp.webp'),
                desc: 'FM WhatsApp vs GB WhatsApp comparison revealing top features, privacy tools, and why FM WhatsApp offers a smarter, safer, and more customizable messaging experience.',
                name: 'FMWhatsApp',
                url: 'https://gbmodshub.com/fm-whatsapp-vs-gb-whatsapp/',
                date: '08/08/2025',
                column: 'WhatsApp Mods',
                link: 'https://gbmodshub.com/whatsapp-mods/'
            },
            {
                title: 'GBWhatsApp QR Chat: Start Conversations Without Saving Numbers',
                poster: require('@/assets/blog-12.webp'),
                desc: 'GBWhatsApp QR Chat lets you start chats instantly without saving numbers, making messaging faster, simpler, and more private for daily use.',
                name: 'blog-12',
                url: 'https://gbmodshub.com/gbwhatsapp-qr-chat/',
                date: '20/08/2025',
                column: 'GB WhatsApp Tricks',
                link: 'https://gbmodshub.com/news/tricks/'
            },
            {
                title: 'How to Send High Quality Pictures in WhatsApp (No Compression)?',
                poster: require('@/assets/blog-13.webp'),
                desc: 'Send high-quality photos on WhatsApp without losing detail. GBWhatsApp lets you share pictures in full resolution, keeping every memory sharp and vibrant for friends and family.',
                name: 'blog-13',
                url: 'https://gbmodshub.com/send-high-quality-pictures-in-whatsapp/',
                date: '27/08/2025',
                column: 'GB WhatsApp Tricks',
                link: 'https://gbmodshub.com/news/tricks/'
            },
            {
                title: 'How to Create and Manage Groups on GB WhatsApp',
                poster: require('@/assets/blog-14-1.webp'),
                desc: 'Learn how to create and manage groups on GB WhatsApp with ease. Discover features, privacy settings, and best practices for smooth group chats.',
                name: 'blog-14',
                url: 'https://gbmodshub.com/create-manage-gwhatsapp-groups/',
                date: '05/09/2025',
                column: 'GB WhatsApp Tricks',
                link: 'https://gbmodshub.com/news/tricks/'
            },
            {
                title: 'How to Create and Manage Groups on GB WhatsApp',
                poster: require('@/assets/blog-15-1.webp'),
                desc: 'Learn how to create and manage groups on GB WhatsApp with ease. Discover features, privacy settings, and best practices for smooth group chats.',
                name: 'blog-15',
                url: 'https://gbmodshub.com/create-manage-gwhatsapp-groups-new/',
                date: '26/09/2025',
                column: 'GB WhatsApp Tricks',
                link: 'https://gbmodshub.com/news/tricks/'
            },
            {
                title: 'How to Use GBWhatsApp for Business Without Compromising Privacy',
                poster: require('@/assets/blog-16-1.webp'),
                desc: 'Learn how to use GBWhatsApp for business while keeping your privacy safe. Learn the best settings, features, and tips to protect sensitive data and manage work chats effectively.',
                name: 'blog-16',
                url: 'https://gbmodshub.com/gbwhatsapp-for-business-privacy/',
                date: '26/09/2025',
                column: 'GB WhatsApp Tricks',
                link: 'https://gbmodshub.com/news/tricks/'
            },
            {
                title: 'How to Lock Chats in GBWhatsApp',
                poster: require('@/assets/blog-17-1.webp'),
                desc: 'Learn how to lock chats in GBWhatsApp using built-in security features. Step-by-step guide to protect private conversations with pattern, PIN, or fingerprint lock.',
                name: 'blog-17',
                url: 'https://gbmodshub.com/lock-chats-gbwhatsapp/',
                date: '12/11/2025',
                column: 'GB WhatsApp Tricks',
                link: 'https://gbmodshub.com/news/tricks/'
            },
            {
                title: 'Why GBWhatsApp Gets Accounts Banned (And How to Avoid It)',
                poster: require('@/assets/blog-24.webp'),
                desc: 'Learn why GBWhatsApp accounts get banned and how to reduce the risk. This guide explains WhatsApp detection systems, common mistakes, and safe usage tips.',
                name: 'blog-24',
                url: 'https://gbmodshub.com/why-gbwhatsapp-get-accounts-banned/',
                date: '16/03/2026',
                column: 'GB WhatsApp Tricks',
                link: 'https://gbmodshub.com/news/tricks/'
            },
            {
                title: 'How to Change the GB WhatsApp Icon in V18.80',
                poster: require('@/assets/blog-25.webp'),
                desc: 'Learn how to change the GB WhatsApp icon in V18.80, explore available icon styles, fix missing icon settings, and restore the default design.',
                name: 'blog-25',
                url: 'https://gbmodshub.com/change-gb-whatsapp-icon/',
                date: '22/10/2026',
                column: 'GB WhatsApp Tricks',
                link: 'https://gbmodshub.com/news/tricks/'
            },
        ],
        // Tricks
        tutorial: [
            {
                title: 'What is GB WhatsApp? Learn How to Use It Safely in 2025',
                poster: require('@/assets/what-is-GB-WhatsApp.webp'),
                desc: "Discover what GB WhatsApp is, how it works, and how to use it securely in 2025. Get insights into features, privacy settings, and safe installation tips to avoid bans or fake APKs.",
                name: 'blog2',
                url: 'https://gbmodshub.com/news/what-is-gbwhatsapp/',
                date:"21/05/2025",
            },
            {
                title: 'How to Install GB WhatsApp Safely',
                poster: require('@/assets/blog-3.webp'),
                desc: "Discover how to install GB WhatsApp safely and quickly on your Android device with this step-by-step guide, including FAQs and expert tips.",
                name: 'blog3',
                url: 'https://gbmodshub.com/how-to-install-gb-whatsapp/',
                date:"23/05/2025",
            },
            {
                title: 'Advanced Customization Options in GB WhatsApp',
                poster: require('@/assets/blog-5.webp'),
                desc: "Discover the advanced customization options in GB WhatsApp that let you personalize chats, privacy settings, themes, and more like never before.",
                name: 'blog5',
                url: 'https://gbmodshub.com/advanced-customization-options-in-gb-whatsapp/',
                date:"28/05/2025",
            },
            {
                title: 'Take Control: Unlocking Enhanced Privacy Settings in GB WhatsApp',
                poster: require('@/assets/blog-6.webp'),
                desc: "Step beyond basic privacy! Discover how Enhanced Privacy Settings in GB WhatsApp give you full control over your digital footprint and secure messaging.",
                name: 'blog6',
                url: 'https://gbmodshub.com/enhanced-privacy-settings-in-gb-whatsapp/',
                date:"04/06/2025",
            },
            {
                title: 'How to Save WhatsApp Status: The Easy Way with GBWhatsApp',
                poster: require('@/assets/saveWhatsAppStatus.webp'),
                desc: "Looking to save WhatsApp Status updates? GBWhatsApp simplifies the process with an integrated download button. One tap is all it takes to keep what matters.",
                name: 'blog9',
                url: 'https://gbmodshub.com/how-to-save-whatsapp-status/',
                date:"16/07/2025",
            },
            {
                title: 'How GB WhatsApp Ensures Strong Data Protection for Users',
                poster: require('@/assets/blog-11.webp'),
                desc: 'Data protection is key with GB WhatsApp. Discover how its unique privacy tools keep your messages, personal info, and conversations secure and private.',
                name: 'blog-11',
                url: 'https://gbmodshub.com/how-gb-whatsapp-protects-your-data/',
                date: '30/07/2025',
            },
            {
                title: 'How to Send High Quality Pictures in WhatsApp (No Compression)?',
                poster: require('@/assets/blog-13.webp'),
                desc: 'Send high-quality photos on WhatsApp without losing detail. GBWhatsApp lets you share pictures in full resolution, keeping every memory sharp and vibrant for friends and family.',
                name: 'blog-13',
                url: 'https://gbmodshub.com/send-high-quality-pictures-in-whatsapp/',
                date: '27/08/2025',
            },
            {
                title: 'How to Create and Manage Groups on GB WhatsApp',
                poster: require('@/assets/blog-14-1.webp'),
                desc: 'Learn how to create and manage groups on GB WhatsApp with ease. Discover features, privacy settings, and best practices for smooth group chats.',
                name: 'blog-14',
                url: 'https://gbmodshub.com/create-manage-gwhatsapp-groups/',
                date: '05/09/2025',
            },
            {
                title: 'How to Create and Manage Groups on GB WhatsApp',
                poster: require('@/assets/blog-15-1.webp'),
                desc: 'Learn how to create and manage groups on GB WhatsApp with ease. Discover features, privacy settings, and best practices for smooth group chats.',
                name: 'blog-15',
                url: 'https://gbmodshub.com/create-manage-gwhatsapp-groups-new/',
                date: '26/09/2025',
            },
            {
                title: 'How to Use GBWhatsApp for Business Without Compromising Privacy',
                poster: require('@/assets/blog-16-1.webp'),
                desc: 'Learn how to use GBWhatsApp for business while keeping your privacy safe. Learn the best settings, features, and tips to protect sensitive data and manage work chats effectively.',
                name: 'blog-16',
                url: 'https://gbmodshub.com/gbwhatsapp-for-business-privacy/',
                date: '26/09/2025',
            },
            {
                title: 'How to Lock Chats in GBWhatsApp',
                poster: require('@/assets/blog-17-1.webp'),
                desc: 'Learn how to lock chats in GBWhatsApp using built-in security features. Step-by-step guide to protect private conversations with pattern, PIN, or fingerprint lock.',
                name: 'blog-17',
                url: 'https://gbmodshub.com/lock-chats-gbwhatsapp/',
                date: '12/11/2025',
            },
            {
                title: 'Why GBWhatsApp Gets Accounts Banned (And How to Avoid It)',
                poster: require('@/assets/blog-24.webp'),
                desc: 'Learn why GBWhatsApp accounts get banned and how to reduce the risk. This guide explains WhatsApp detection systems, common mistakes, and safe usage tips.',
                name: 'blog-24',
                url: 'https://gbmodshub.com/why-gbwhatsapp-get-accounts-banned/',
                date: '16/03/2026',
            },
            {
                title: 'How to Change the GB WhatsApp Icon in V18.80',
                poster: require('@/assets/blog-25.webp'),
                desc: 'Learn how to change the GB WhatsApp icon in V18.80, explore available icon styles, fix missing icon settings, and restore the default design.',
                name: 'blog-25',
                url: 'https://gbmodshub.com/change-gb-whatsapp-icon/',
                date: '22/10/2026',
            },
        ],
        mods:[
            {
                title: 'FM WhatsApp vs GB WhatsApp Features: What Makes FM Stand Out',
                poster: require('@/assets/fm-whatsapp-vs-gb-whatsapp.webp'),
                desc: 'FM WhatsApp vs GB WhatsApp comparison revealing top features, privacy tools, and why FM WhatsApp offers a smarter, safer, and more customizable messaging experience.',
                name: 'FMWhatsApp',
                url: 'https://gbmodshub.com/fm-whatsapp-vs-gb-whatsapp/',
                date: '08/08/2025',
                column: 'WhatsApp Mods',
                link: 'https://gbmodshub.com/whatsapp-mods/'
            }
        ],
        // Update
        shooting:[
            {
                title: 'GB WhatsApp Update Latest version v18.50',
                poster: require('@/assets/Update-V1840.webp'),
                desc: "Discover the latest features in GB WhatsApp v18.50,including whether it is necessary to update GBWhatsApp, the latest version features, how to update to the latest version, etc.",
                name: 'blog1',
                url: 'https://gbmodshub.com/news/gb-whatsapp-update-v1840/',
                date:"21/05/2025",
            },
            {
                title: 'How to Update GB WhatsApp: A Complete Guide for 2025',
                poster: require('@/assets/blog-4.webp'),
                desc: "Learn how to safely update GB WhatsApp TDK to the latest version. Follow our step-by-step guide to back up your chats, install the new APK.",
                name: 'blog4',
                url: 'https://gbmodshub.com/how-to-update-gb-whatsapp/',
                date:"26/05/2025",
                // column: 'GBWhatsApp Update',//栏目
                // link:'https://gbmodshub.com/news/tricks/',
            },
            {
                title: 'GB WhatsApp v18.60 Released – Fixed Banned Numbers & More!',
                poster: require('@/assets/blog-10.webp'),
                desc: 'GB WhatsApp v18.60 fixes banned number issues, adds new privacy tools, performance upgrades, and fresh themes—download the July 2025 update now!',
                name: 'blogs-10',
                url: 'https://gbmodshub.com/gb-whatsapp-v18.60-released-fixed-banned-numbers/',
                date: '22/07/2025',
            },
        ],
        news: [  {
                title: 'Why Is My Phone Not Downloading or Installing GB WhatsApp?',
                poster: require('@/assets/blog-7.webp'),
                desc: "Trouble installing GB WhatsApp on Android? Learn why your phone won't download or install the APK and how to fix issues like unknown sources, Play Protect, storage, and version compatibility.",
                name: 'blog7',
                url: 'https://gbmodshub.com/gb-whatsapp-not-install-or-download-fix/',
                date:"13/06/2025",
            },
            {
                title: 'Why GB WhatsApp Risks Don\'t Stop Its Users',
                poster: require('@/assets/gb-whatsapp-risks.webp'),
                desc: "GB WhatsApp risks haven't stopped users from downloading it. Discover why it remains popular in 2025 and how to stay safe with the latest version.",
                name: 'gb-whatsapp-risks-blog',
                url: 'https://gbmodshub.com/why-gb-whatsapp-risks-don\'t-stop-its-users/',
                date:"01/07/2025",
            }
        ]
    }
    
}